import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import Posts from '../../components/Posts/Posts';
import CTASimple from '../../components/CTASimple/CTASimple';
import theme from '../../styles/theme';
import HeroOverlap from '../../components/HeroOverlap/HeroOverlap';
import ButtonLink from '../../components/Shared/ButtonLink';
import Accordion from '../../components/Accordion/Accordion';
import Error from '../../components/Error/Error';
import { getPageContent } from '../../services/dpc';
import ReactMarkdown from 'react-markdown';
import { slugByLabel } from '../../util/faqCategories';

function FHAMortgage({
  data: {
    contentCTAs,
    contentVideos,
    faqPod,
    heroCta,
    heroMedia,
    mobileHeroMedia,
    metaDescription,
    preFooterCta,
    tipsAndToolsPod,
    titleTag,
    customerReviewPod,
  } = {},
  error,
  isLoading,
}) {
  if (error) {
    console.error(error);
    return (
      <Layout>
        <Error />
      </Layout>
    );
  }

  const faqs =
    faqPod &&
    faqPod.map(
      ({
        faqQuestion: title,
        faqSummaryAnswer: answer,
        slug,
        faqCategory,
        ...rest
      }) => ({
        title,
        answer,
        showReadMore:
          rest.faqAnswerContent1 ||
          rest.faqAnswerContent2 ||
          rest.faqAnswerVideos,
        slug: slug.replace(
          'resources/faqs/',
          `resources/faqs/${slugByLabel(faqCategory?.[0])}/`
        ),
      })
    );

  const posts =
    tipsAndToolsPod &&
    tipsAndToolsPod.map(
      ({ title, contentTag, category, slug, featuredMedia }) => ({
        title,
        category,
        contentTag,
        thumbnail: `${featuredMedia?.media?.fields?.file?.url}?w=300`,
        slug,
      })
    );

  return (
    <Layout isLoading={isLoading}>
      <SEO title={titleTag} description={metaDescription} />

      <HeroOverlap
        position='left'
        background={heroMedia?.[0]?.media?.fields?.file?.url}
        mobileBackground={mobileHeroMedia?.[0]?.media?.fields?.file?.url}
        alt={heroMedia?.[0]?.altText}
      >
        <h1>{heroCta?.ctaHeader}</h1>
        <ReactMarkdown
          source={heroCta?.ctaIntro}
          renderers={{
            link: ({ href, children }) => (
              <a target='_blank' href={href}>
                {children}
              </a>
            ),
          }}
        />
        <section className='links'>
          <ButtonLink
            appearance='dark'
            to={heroCta?.firstCTAButtonUrl}
            isExternal={true}
            newTab={true}
            size='large'
          >
            {heroCta?.firstCTAButtonText}
          </ButtonLink>
        </section>
      </HeroOverlap>

      <Accordion items={faqs} />

      <CTASimple
        title={contentCTAs?.[0]?.ctaHeader}
        link={{
          title: contentCTAs?.[0].firstCTAButtonText || 'Estimate Payment',
          size: 'large',
          to:
            contentCTAs?.[0]?.firstCTAButtonUrl ||
            '/calculators/mortgage-calculator/',
        }}
        condensed={true}
      >
        <p>{contentCTAs?.[0]?.ctaIntro}</p>
      </CTASimple>

      <Posts
        title='Tips & Tools'
        link={{ title: 'View All', to: '/resources/blog/' }}
        posts={posts}
      />

      <CTASimple
        title={preFooterCta?.ctaHeader || 'We Can Help You Get Started'}
        link={{
          to: preFooterCta?.firstCTAButtonUrl || '/applynow/welcome/',
          title: preFooterCta?.firstCTAButtonText || 'Apply Today',
          size: 'large',
          isExternal: true,
          newTab: true,
        }}
        background={theme.colors.vmfBlue}
      ></CTASimple>
    </Layout>
  );
}

FHAMortgage.getInitialProps = async ({}) => {
  try {
    const data = await getPageContent('/fha-mortgage/');

    if (data.status !== 200) {
      throw data.statusText;
    }

    return {
      data: data.data.result,
    };
  } catch (error) {
    return {
      error,
    };
  }
};

FHAMortgage.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  data: PropTypes.shape({}),
  error: PropTypes.object,
};

export default FHAMortgage;
